<template>
  <v-col cols="12" class="px-0">
    <raster-catalog-fields :value="form" :errors="errors" />
    <field-group
      v-if="isCreate"
      v-model="form.file"
      :error-messages="errors.file || errors.files"
      typeInput="field-file-input"
      :rules="fileRules"
      accept=".tif,.tiff"
      allow-directory
      multiple
      title="Tải GeoTIFF"
    ></field-group>
  </v-col>
</template>

<script>
import RasterCatalogFields from './raster-catalog-fields.vue'

export default {
  components: { RasterCatalogFields },
  props: {
    value: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    isCreate: Boolean,
  },
  data: () => ({
    fileRules: [
      (v) => {
        if (Array.isArray(v)) {
          return v.length > 0 || 'File không thể bỏ trống'
        }
        return !!v || 'File không thể bỏ trống'
      },
    ],
  }),
  computed: {
    form() {
      return this.value
    },
  },
}
</script>
